var _rect, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusNotconfirmed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#9747FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.4381,
    y1: 7.12113,
    x2: 7.12133,
    y2: 22.0287,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 22.8738,
    y2: -1.5,
    transform: "matrix(0.716614 0.69747 0.69747 -0.716614 7 5)",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusNotconfirmed);
export default __webpack_public_path__ + "static/media/status-notconfirmed.edbda5324ea67af0a53ef61fcd4641a7.svg";
export { ForwardRef as ReactComponent };